import request from './request'
const APPID = process.env.APPID
export function getBooksList() {
  let key = 'list_ebook.json'
  if (window.location.href.indexOf('tjebook') !== -1) {
    key = 'list.json'
  }
  return request({
    url: '/books/appwx/' + key,
    method: 'get',
    params: {}
  })
}

export function getBookdata(bookid) {
  return request({
    // url: "https://ebook.nse.cn/books/appwx/" + bookid + "/wxjson/book.json",
    url: '/ucenter/obs/' + bookid + '.nse',
    method: 'get',
    params: {}
  })
}

export function getPagedata(bookid, pageid) {
  return request({
    url: '/ucenter/obs/' + bookid + '/' + pageid + '.nse',
    method: 'get',
    params: {}
  })
}

export function getTransdata(bookid, pageid, cid, token) {
  return request({
    url: '/ucenter/obs/' + bookid + '/' + pageid + '/trans.nse',
    method: 'get',
    params: {
      res: cid,
      token: token
    }
  })
}

export function getCatalog(bookid, token) {
  return request({
    url: '/ucenter/obs/' + bookid + '/catalog.nse',
    method: 'get',
    params: {
      token: token
    }
  })
}

export function getBookResource(bookid, resourceType) {
  return request({
    url: `/ucenter/obs/${bookid}/${resourceType}.nse`,
    method: 'post',
    params: {}
  })
}

export function getBookId(bookid) {
  return request({
    url: `/ucenter/user/getBookIdByName/${bookid}.nse?appid=${APPID}`,
    method: 'get',
    params: {}
  })
}

export function getToken(usessionid) {
  return request({
    url: `/ucenter/api/v1/user/registerandlogin.nse`,
    method: 'post',
    params: {
      usessionid,
      appid: APPID
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/books.js